/**
 * Created by Ivan on 09.04.2026
 */

const HungryGamesTutorial = function (mission) {
    return new TutorialScenario(HungryGamesTutorial.NAME, {
        listSteps: function () {
            return HungryGamesTutorial.listSteps(mission);
        },
        onStart: function () {},
        onFinish: function () {}
    });
};

HungryGamesTutorial.listSteps = function (mission) {
    return [
        HungryGamesTutorial.createWindowStep(mission),
        HungryGamesTutorial.createPlayersForceStep(),
        HungryGamesTutorial.createStarForceStep(),
        HungryGamesTutorial.createChestForceStep(),
        HungryGamesTutorial.createGuideWindowStep(),
        HungryGamesTutorial.createWaitGuideWindowCloseStep()
    ];
};

HungryGamesTutorial.createWindowStep = function (mission) {
    return new TutorialStep({
        onStart: function () {
            cleverapps.focusManager.display({
                stack: true,
                focus: "HungryGamesWindow",
                action: function (f) {
                    new HungryGamesWindow(mission);
                    cleverapps.focusManager.onceNoWindowsListener = f;
                }
            });

            cleverapps.tutorial.on("window_shown", (options) => {
                if (options.windowName === "HungryGamesWindow") {
                    this.finish();
                }
            }, this);
        },

        onFinish: function () {
            cleverapps.tutorial.startNextStep();
        }
    });
};

HungryGamesTutorial.createPlayersForceStep = function () {
    const createForce = function () {
        const window = cleverapps.focusManager.currentWindow();
        const avatarGroup = ComponentUtils.findChildByName(window, "avatarGroup");
        const avatars = avatarGroup ? avatarGroup.getChildren() : [];

        return cleverapps.forces.create(avatarGroup, Forces.HUNGRY_GAMES, {
            highlights: avatars,
            importantNodes: avatars,
            onSkip: () => cleverapps.tutorial.skip()
        });
    };

    return new TutorialStep({
        onStart: function () {
            this.force = createForce();

            if (!this.force) {
                this.finish();
                return;
            }

            cleverapps.forces.onceForceClosed = function () {
                this.finish();
            }.bind(this);

            cleverapps.tutorial.on("onResize", () => {
                this.force && this.force.close();
                this.force = createForce();
            }, this);
        },

        onFinish: function () {
            if (this.force) {
                this.force.hideForceHints();
            }
            cleverapps.tutorial.startNextStep();
        }
    });
};

HungryGamesTutorial.createStarForceStep = function () {
    const createForce = function () {
        const window = cleverapps.focusManager.currentWindow();
        const staircase = ComponentUtils.findChildByName(window, "background3");
        const levelsCounter = ComponentUtils.findChildByName(window, "levelsCounter");

        const steps = [];
        if (staircase) {
            steps.push(staircase);
        } else {
            const nextStar = ComponentUtils.findChildByName(window, "star_0");
            if (nextStar) {
                steps.push(nextStar);
            }
        }

        const nodes = levelsCounter ? steps.concat([levelsCounter]) : steps;

        return cleverapps.forces.create(steps[0], {
            text: "HungryGames.Force.Star",
            finger: false,
            closeByTouchInShadow: true
        }, {
            highlights: nodes,
            highlightActives: false,
            importantNodes: levelsCounter ? [levelsCounter] : [],
            onSkip: () => cleverapps.tutorial.skip()
        });
    };

    return new TutorialStep({
        onStart: function () {
            this.force = createForce();

            if (!this.force) {
                this.finish();
                return;
            }

            cleverapps.forces.onceForceClosed = function () {
                this.finish();
            }.bind(this);

            cleverapps.tutorial.on("onResize", () => {
                this.force && this.force.close();
                this.force = createForce();
            }, this);
        },

        onFinish: function () {
            if (this.force) {
                this.force.hideForceHints();
            }
            cleverapps.tutorial.startNextStep();
        }
    });
};

HungryGamesTutorial.createChestForceStep = function () {
    const createForce = function () {
        const window = cleverapps.focusManager.currentWindow();
        const chest = ComponentUtils.findChildByName(window, "chestBase");

        return cleverapps.forces.create(chest, {
            text: "HungryGames.Force.Chest",
            finger: false,
            closeByTouchInShadow: true
        }, {
            highlights: [chest],
            importantNodes: [chest].concat(chest.getChildren()),
            onSkip: () => cleverapps.tutorial.skip()
        });
    };

    return new TutorialStep({
        onStart: function () {
            this.force = createForce();

            if (!this.force) {
                this.finish();
                return;
            }

            cleverapps.forces.onceForceClosed = function () {
                this.finish();
            }.bind(this);

            cleverapps.tutorial.on("onResize", () => {
                this.force && this.force.close();
                this.force = createForce();
            }, this);
        },

        onFinish: function () {
            if (this.force) {
                this.force.hideForceHints();
            }
            cleverapps.tutorial.startNextStep();
        }
    });
};

HungryGamesTutorial.createGuideWindowStep = function () {
    return new TutorialStep({
        onStart: function () {
            const window = cleverapps.focusManager.currentWindow();
            if (window) {
                ComponentMap.get(window, WindowComponent).closeWindow();
            }

            new HungryGamesGuideWindow();

            cleverapps.tutorial.on("window_shown", () => this.finish(), this);
        },

        onFinish: function () {
            cleverapps.tutorial.startNextStep();
        }
    });
};

HungryGamesTutorial.createWaitGuideWindowCloseStep = function () {
    return new TutorialStep({
        onStart: function () {
            const window = cleverapps.focusManager.currentWindow();
            if (!window) {
                this.finish();
                return;
            }

            cleverapps.focusManager.setEventNodes([window]);
            cleverapps.tutorial.on("window_closed", () => this.finish(), this);
        },

        onFinish: function () {
            cleverapps.tutorial.startNextStep();
        }
    });
};

HungryGamesTutorial.NAME = "hungry_games_tutorial";